import { render, staticRenderFns } from "./AdvertPromo.vue?vue&type=template&id=4b39b2cf&scoped=true&"
import script from "./AdvertPromo.vue?vue&type=script&lang=js&"
export * from "./AdvertPromo.vue?vue&type=script&lang=js&"
import style0 from "./AdvertPromo.vue?vue&type=style&index=0&id=4b39b2cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b39b2cf",
  null
  
)

export default component.exports